import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { FalhasCriticasAtivas } from "../../types";
import { colorList } from "./GeneratedEnergyCharts";

export default function FalhasCriticasAtivasChart(props: {
    data: FalhasCriticasAtivas[],
}) {
    const { data } = props

    const hasData = Object.keys(data).length > 0

    const allAlarmCodes = new Set<string>();
    data.forEach(usina => {
        usina.falhasPorAlarmeCode?.forEach(falha => {
            allAlarmCodes.add(falha.alarmCode);
        });
    });
    const uniqueAlarmCodes = Array.from(allAlarmCodes);

    const rawData: number[][] = uniqueAlarmCodes.map(alarmCode => {
        return data.map(usina => {
            const falha = usina.falhasPorAlarmeCode?.find(f => f.alarmCode === alarmCode);
            return falha ? falha.quantidadeDeFalhas : 0;
        });
    });

    const usinasCodes = data.map(usina => usina.usinaCode);

    const series = uniqueAlarmCodes.map((alarmCode, sid) => {
        return {
            name: alarmCode,
            type: 'bar' as const,
            stack: 'total',
            barWidth: '60%',
            label: {
                show: true,
                formatter: (params: any) => {
                    return params.value > 0 ? params.value.toString() : '';
                },
                color: '#fff'
            },
            data: rawData[sid] || [],
            itemStyle: {
                color: colorList[sid % colorList.length] || '#5470c6'
            }
        };
    });

    const options: EChartsOption = {
        title: {
            text: "Número de falhas criticas ativas na planta",
            textStyle: {
                fontSize: 12,
            },
        },
        legend: {
            selectedMode: false,
            top: 10
        },
        grid: {
            left: 0,
            right: 0,
            bottom: 0,
            containLabel: true,
        },
        backgroundColor: "transparent",
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow"
            },
            confine: true,
            formatter: (params: any) => {
                if (!Array.isArray(params)) return '';

                let result = `<strong>${params[0].axisValue}</strong><br/>`;
                let total = 0;

                params.forEach((param: any) => {
                    if (param.value > 0) {
                        result += `${param.marker} ${param.seriesName}: ${param.value}<br/>`;
                        total += param.value;
                    }
                });

                result += `<strong>Total: ${total}</strong>`;
                return result;
            }
        },
        yAxis: {
            type: 'value',
            name: 'Quantidade de Falhas',
            nameLocation: 'middle',
            nameGap: 50
        },
        xAxis: {
            type: 'category',
            nameLocation: 'middle',
            nameGap: 30,
            data: usinasCodes,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 10,
                rotate: 65,
                interval: 0
            },
        },
        series
    }

    return (
        <>
            {hasData ? (
                <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "90%",
                        width: "100%",
                    }}
                >
                    <RopChart option={options} />
                </Container>
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <EmptyTable title="Nenhum dado encontrado!" />
                </Box>
            )}
        </>
    );
}
